import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';

import { getToast } from '../utils/toastConfig';
import { GlobalVariables } from '../globalVar';
import customAxios from '../utils/customAxios';
import { ModelTable } from '../components/Tables/ModelTable';

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

const ModelPage = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const response = await customAxios.get(
        `${GlobalVariables.getURL()}models/?includeInactive=true`,
        HEADERS,
      );
      if (response.status === 204) {
        setData([]);
        return;
      }
      setData(response.data.data || response.data || []);
    } catch (error) {
      console.log('Error fetching models:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>DABI | Modelos</title>
      </Helmet>
      <div className='datatable'>
        <ModelTable data={data} isFetching={isFetching} fetchData={fetchData} />
      </div>
    </div>
  );
};

export default ModelPage;
